import React from "react";
import { ReserveFieldTitle } from "@/features/reserve/components/ReserveFieldTitle/ReserveFieldTitle";
import { cn } from "@gettactic/helpers";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";

export interface ReserveFormMeetingRoomTitleProps {
  className?: string;
}

export const ReserveFormMeetingRoomTitle: React.FC<
  ReserveFormMeetingRoomTitleProps
> = ({ className }) => {
  const { isMeetingRoom, form } = useReserveForm();
  if (!isMeetingRoom) return null;

  return (
    <div className={cn("", className)}>
      <ReserveFieldTitle form={form} withDescription />
    </div>
  );
};
